import { c as _c } from "react/compiler-runtime";
import { ExternalLinks } from "@components/external-links";
import { Alert } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { runtimeConfig } from "@src/runtime-config";
/** Name to display for the ACC account for each region */
const ACCOUNT_NAME = {
  com: "ACC account",
  eu: "ACC EU account"
};

/** Account name */
const accountName = ACCOUNT_NAME[runtimeConfig.appRegion];

/** App name to look for in the ACC App Gallery for each region */
const APP_NAME = {
  com: "FARO Sphere® XG/HoloBuilder",
  eu: "FARO Sphere® XG/HoloBuilder EU"
};

/** App name */
const appName = APP_NAME[runtimeConfig.appRegion];

/** Information on how to install the Sphere XG app in an ACC account */
export function ConnectDialogAutodeskHint() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div>If your {accountName} is missing from the list of hubs, it may be because the Sphere XG app is not installed in your {accountName}. Look for the app named "{appName}" in the ACC App Gallery.{" "}<ExternalLinks text="See this article" link="autodeskAppStoreArticle" />{" "}to learn how to install it.</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Alert title={`You don't see your ${accountName} listed below?`} variant="info" isCollapsible={true} description={<>{t0}<Box sx={{
        mt: 1
      }}><ExternalLinks text="Learn more" link="sphereXGAccIntegration" />{" about the ACC integration with Sphere XG."}</Box></>} sx={{
      mb: "8px"
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}